import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { catchError, map } from 'rxjs/operators';
import { ActivityManagementService } from '../../activity-management.service';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { DatePipe } from 'src/app/shared/pipe/date.pipe';
import { of } from 'rxjs';

@Component({
  selector: 'app-modal-consult',
  templateUrl: './modal-consult.component.html',
  styleUrls: ['./modal-consult.component.scss']
})
export class ModalConsultComponent {
  modalData: any;
  date: Date;
  time: string;
  textError: string = null;
  consultForm: FormGroup = null;
  isEdit: boolean = false;
  timeStart: Date;
  timeEnd: Date;
  isLoading: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalConsultComponent>,
    private activityManagementService: ActivityManagementService,
    private fb: FormBuilder,
  ) {
    this.modalData = data;
    this.consultForm = this.fb.group({
      type: ['', Validators.required],
      max: [1, Validators.required],
      solution: ['', Validators.required],
      object: [''],
    })
    // console.log(this.modalData);

    if (data.isEdit) {
      this.date = new Date(data.value.CONSULT_DATE_START);
      this.time = this.getTime(data.value, data.isEdit);
    } else {
      if (data.isJoined) {
        this.date = new Date(data.value.CONSULT_DATE_START);
        this.time = this.getTime(data.value, true);
      } else {
        this.date = new Date(data.value.CONSULT_DATE);
        this.time = this.getTime(data.value, data.isEdit);
      }
    }
  }

  create(v) {
    // console.log(v);

    let obj = {
      USER_ID: this.modalData.uid,
      CONSULT_ID: '',
      CONSULT_CREATE_TYPE: 'create',
      CONSULT_TYPE: v.type,
      CONSULT_DATE_START: this.timeStart,
      CONSULT_DATE_END: this.timeEnd,
      CONSULT_MAX: v.max === '' ? 0 : v.max,
      CONSULT_SOLUTION: v.solution,
      CONSULT_OBJECT: v.object
    }
    if (v.max <= 50000 && v.max > 0) {
      this.dialogRef.close({ status: true, obj });
    } else {
      if (v.max >= 50000) alert('จำนวนผู้เข้าร่วมสูงสุดไม่เกิน 50,000 คน กรุณาลองใหม่อีกครั้ง')
      else if (v.max <= 0) alert('จำนวนผู้เข้าร่วมขั้นต่ำ 1 คน กรุณาลองใหม่อีกครั้ง')
    }
  }

  edit(v) {
    // console.log(v);

    let obj;

    if (this.modalData.value.CONSULT_ID) {
      if (this.modalData.isJoined) {
        obj = {
          USER_ID: this.modalData.uid,
          CONSULT_ID: this.modalData.value.CONSULT_ID,
          CONSULT_CREATE_TYPE: 'edit',
          CONSULT_TYPE: this.modalData.value.CONSULT_TYPE,
          CONSULT_DATE_START: this.timeStart,
          CONSULT_DATE_END: this.timeEnd,
          CONSULT_MAX: v.max === '' ? 0 : v.max,
          CONSULT_SOLUTION: v.solution,
          CONSULT_OBJECT: this.modalData.value.CONSULT_OBJECT
        }
      } else {
        obj = {
          USER_ID: this.modalData.uid,
          CONSULT_ID: this.modalData.value.CONSULT_ID,
          CONSULT_CREATE_TYPE: 'edit',
          CONSULT_TYPE: v.type,
          CONSULT_DATE_START: this.timeStart,
          CONSULT_DATE_END: this.timeEnd,
          CONSULT_MAX: v.max === '' ? 0 : v.max,
          CONSULT_SOLUTION: v.solution,
          CONSULT_OBJECT: v.object
        }
      }
    } else {
      obj = {
        USER_ID: this.modalData.uid,
        CONSULT_ID: '',
        CONSULT_CREATE_TYPE: 'create',
        CONSULT_TYPE: v.type,
        CONSULT_DATE_START: this.timeStart,
        CONSULT_DATE_END: this.timeEnd,
        CONSULT_MAX: v.max === '' ? 0 : v.max,
        CONSULT_SOLUTION: v.solution,
        CONSULT_OBJECT: v.object
      }
    }
    // // console.log(v);
    if (v.max <= 50000 && v.max > 0 && (v.max >= this.modalData.value.CONSULT_REGISTER || !this.modalData.value.CONSULT_REGISTER)) {
      this.dialogRef.close({ status: true, obj });
    } else {
      if (v.max >= 50000) alert('จำนวนผู้เข้าร่วมสูงสุดไม่เกิน 50,000 คน กรุณาลองใหม่อีกครั้ง')
      else if (v.max <= 0) alert('จำนวนผู้เข้าร่วมขั้นต่ำ 1 คน กรุณาลองใหม่อีกครั้ง')
      else if (v.max < this.modalData.value.CONSULT_REGISTER) alert('จำนวนผู้เข้าร่วมสูงสุดไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง')
    }
  }

  closeModal() {
    const response = {
      status: false,
      value: {}
    }

    this.dialogRef.close(response);
  }

  downloadExcelByDateTime() {
    this.isLoading = true;
    const body = {
      USER_ID: this.modalData.uid,
      CONSULT_ID: this.modalData.value.CONSULT_ID
    }
    this.activityManagementService.exportCalendaConsultById(body).pipe(
      map(res => {
        // console.log(res);

        const _data = [];

        res.result.map(d => {
          _data.push({
            'CONSULT_ID': d.CONSULT_ID,
            'อาจารย์': d.USERNAME,
            'ประเภท': d.CONSULT_TYPE,
            'ลักษณะการเข้าร่วม': this.modalData.value.CONSULT_TYPE,
            'หัวข้อการเข้าร่วม': d.CONSULT_CATEGORY,
            'วัน-เวลาเข้ารับ consult': `${new DatePipe().transform(d.CONSULT_DATE_START.toString(), 'date')} ${this.addZeroBefore(new Date(d.CONSULT_DATE_START).getHours())}:00 - ${this.addZeroBefore(new Date(d.CONSULT_DATE_END).getHours())}:00 น.`,
            'รายละเอียดเพิ่มเติม': d.MORE_DETAIL,
            'ประเภทการเข้าร่วม': d.CONSULT_JOIN_TYPE,
            'จำนวนผู้เข้าร่วมสูงสุด': d.CONSULT_MAX,
            'วิธีการเข้าร่วม': d.CONSULT_SOLUTION,
            'จองแล้ว': `${d.CUSTOMER_NAME} (${d.CONSULT_COUNT_REGISTER} คน)`,
            'ชำระทั้งหมด': d.CONSULT_TOTAL_PRICE + ' บาท',
            'สถานะการชำระ': d.CONSULT_STATUS,
          })
        })

        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(_data);
        const workbook: XLSX.WorkBook = {
          Sheets: { Sheet1: worksheet },
          SheetNames: ['Sheet1'],
        };

        const excelBuffer: any = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array',
        });

        const data: Blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });

        FileSaver.saveAs(data, `${res.result[0].CONSULT_SOLUTION}_${_data[0]['วัน-เวลาเข้ารับ consult'].replace(/\./g, ' ')}`);
        this.isLoading = false;
      }),
      catchError((err) => {
        alert(err.error.message);
        return of(false);
      })
    ).subscribe();
  }

  delete(v) {
    let obj;
    // // console.log(v.value);

    if (this.modalData.value.CONSULT_ID) {
      obj = {
        USER_ID: this.modalData.uid,
        CONSULT_ID: this.modalData.value.CONSULT_ID,
        CONSULT_CREATE_TYPE: 'delete',
        CONSULT_TYPE: v.type,
        CONSULT_DATE_START: this.timeStart,
        CONSULT_DATE_END: this.timeEnd,
        CONSULT_MAX: v.max === '' ? 0 : v.max,
        CONSULT_OBJECT: v.object
      }
    } else {
      obj = null
    }
    this.dialogRef.close({ isDelete: true, obj });
  }

  getTime(e, isEdit): string {
    let time
    if (isEdit) {
      this.timeStart = new Date(e.CONSULT_DATE_START);
      this.timeEnd = new Date(e.CONSULT_DATE_END);
    } else {
      this.timeStart = new Date(e.CONSULT_DATE);
      this.timeEnd = new Date(new Date(e.CONSULT_DATE).setHours(this.timeStart.getHours() + 1, 0, 0));
    }

    time = `${this.addZeroBefore(this.timeStart.getHours())}: 00 - ${this.addZeroBefore(this.timeEnd.getHours())}: 00 น.`

    return time;
  }

  addZeroBefore(n) {
    return (n < 10 ? '0' : '') + n;
  }
}
